"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SafeCast__factory", {
  enumerable: true,
  get: function get() {
    return _SafeCast__factory.SafeCast__factory;
  }
});
var _SafeCast__factory = require("./SafeCast__factory");